import { FelaCSS, colors } from '@bridebook/ui';

interface IStyles {
  heading: FelaCSS;
}

const styles = (): IStyles => ({
  heading: {
    fontDefault: 16,
    lineHeight: '20px',
    color: colors.space,
    textTransform: 'none',
  },
});

export default styles;
